export const generateComponentDocs = (problemDescription, howToUse, currentUsage, relatedComponents) => ({
  docs: {
    description: {
      component: `        
  ## ** What problem does it solve?**
  ${problemDescription}


  ## ** When & how to use it?**
  ${howToUse}


  ## ** Current Usage**
  ${currentUsage}


  ## ** Related Components**
  ${relatedComponents}
  
  `,
    },
  },
});

export const generateStoryDocs = (variantUse, variantCurrentUse) => ({
  docs: {
    description: {
      story: `
  ## ** When is this variant used?**
  ${variantUse}


  ## ** Where is it currently used on the product?**
  ${variantCurrentUse}
  
  `,
    },
  },
});
